import { Card, Tabs, BlockStack } from '@shopify/polaris';
import React, { useEffect } from 'react';
import { useState, useCallback } from 'react';
import Accounts from './Component/Accounts/Accounts';
import ProductSettings from './Component/Product Settings/ProductSettings';
import { DI, DIProps } from '../../../Core';
import { Navigate, Route, Routes } from 'react-router-dom';
import OrderSettings from './Component/Order Settings/OrderSettings';
import TemplateSettings from './Component/Template Settings/TemplateSettings';
import SandboxSettings from './Component/Sandbox Settings/SandboxSettings';
import './css/styles.css';
// import AmazonLocalSelling from './Component/Local Selling/AmazonLocalSelling';
import Uninstallation from "./UninstallChannel"
import Notifications from './Component/Notifications/Notifications';
import { isAdminLoggedIn } from '../Panel/index';
import ColumnGroup from 'antd/es/table/ColumnGroup';
import ConfigTour from './ConfigTour';
import { useTour } from '../../Other/tour';
import MultiLangSetting from './Component/MultiLangSetting/MultiLangSetting';
import { useTranslation } from 'react-i18next';
import StaffUserManagement from '../StaffUserManagement/StaffUserManagement';
import AddLabel from '../AddLabel/AddLabel';


const NewSettings = (props: DIProps) => {
  const { t } = useTranslation();
  const { setCurrentStep, isOpen, currentStep } = useTour()

  const tabs = [
    {
      id: 'accounts',
      content: t('Accounts'),
      section: <Accounts />,
    },
    {
      id: 'notifications',
      content: t('Notifications'),
      section: <Notifications />,
    },
    {
      id: 'productsettings',
      content: t('Product Settings'),
      section: <ProductSettings />,
    },
    {
      id: 'ordersettings',
      content: t('Order Settings'),
      section: <><OrderSettings /></>,
    },
    {
      id: 'templateSettings',
      content: t('Templates'),
      section: <><TemplateSettings /> </>,
    },
    {
      id: 'staffManagement',
      content: t('Staff Management'),
      section: <><StaffUserManagement /> </>,
    },
    ...(isAdminLoggedIn() || process.env.REACT_APP_PROD === "0") ? [{
      id: 'Label',
      content: 'Label',
      section: <><AddLabel /></>,
    }] : [],
    ...isAdminLoggedIn() ? [{
      id: 'sandbox',
      content: t('Sandbox'),
      section: <><SandboxSettings /> </>,
    }] : [],
  ]
  const tabsArray = ['accounts', 'notifications', 'productSettings', 'orderSettings', 'templateSettings', 'staffManagement', 'sandbox'];

  let path = props.location.pathname.split('/').reverse();

  let tabForPath = tabsArray.indexOf(tabsArray.includes(path?.[0] ?? 'accounts') ? path?.[0] : tabsArray.includes(path?.[1] ?? 'accounts') ? path?.[1] : 'accounts')
  const [selected, setSelected] = useState(tabForPath);

  const handleTabChange = useCallback(
    (selectedTabIndex: number) => {
      setSelected(selectedTabIndex);
      props.history(tabsArray[selectedTabIndex]);
      if (tabsArray[selectedTabIndex] === 'templateSttings' && isOpen && props.di.globalState.get('start_tour') === 'bulk_upload_1') {
        if (currentStep === 1) {
          setCurrentStep(2)
        }
      }
    },
    [],
  );

  useEffect(() => {
    setSelected(tabForPath)
  }, [tabForPath])


  return (
    <BlockStack gap="600">
      <div className='bulktour_tab1'>
        <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange} />
      </div>
      <Card roundedAbove='sm'>
        <Routes>
          <Route path={`${tabsArray[selected]}/*`} element={
            tabs[selected]?.section
          } />
          <Route path="*" element={<Navigate to={'accounts'} />} />
        </Routes>
      </Card>
      {selected == 0 && <MultiLangSetting />}
      {selected == 0 && <Uninstallation />}
      <ConfigTour handleTabChange={handleTabChange} templateSettingsIndex={tabs.findIndex(data => data.id === 'templateSettings')} currentSelectedIndex={selected} />
    </BlockStack>
  );
}

export default DI(NewSettings);